// This function is used to determine the color of progress bar based on the percentage input
const determineProgressColor = (percentage, theme, warnWhenComplete) => {
    let themeStatus;
    if (warnWhenComplete && percentage >= 100) {
        themeStatus = theme.progressBar.error;
    }
    else if (percentage >= 100) {
        themeStatus = theme.progressBar.complete;
    }
    else {
        themeStatus = theme.progressBar.inProgress;
    }
    return themeStatus;
};
export default determineProgressColor;
//# sourceMappingURL=helpers.js.map